 
import { routes } from "../../../../routers/routes";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import PricingPlan from "./PricingPlan";
import Newsletter from "../../../home/common/Newsletter";

const PricingContainer = () => {
  return (
    <>
      <Breadcrumbs title="Pricing" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <PricingPlan />
      <Newsletter type="pricing" />
    </>
  );
};

export default PricingContainer;
